var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-img',{staticClass:"mr-2 site_favicon",attrs:{"src":_vm.src,"width":"16","height":"16"}})
}
var staticRenderFns = []

export { render, staticRenderFns }